// per-tab sessionStorage key holding the email
// captured at /account/check-email. sessionStorage is per-tab, so a concurrent submission
// in another tab can't overwrite it; keeping it out of any cookie keeps the
// PII out of request headers and server logs. Shared between the ptvSisu flow
// (writer) and the PTV appshell client email-checkpoint guard (reader).
export const EMAIL_STORAGE_KEY = 'tn:sisuEmail';

export const ACTIVATION_CODE_STORAGE_KEY = 'ptv_sisu_activation_code';
